module.exports = __webpack_public_path__ + "img/Hawaiian_Meal_Gardein_Soy_Chicken.ef90de94.jpg";